import { ISoundsConfiguration } from '@GFTypes/GameStoreTypes';

export const SOUND_CONFIGURATION_DEFAULTS: ISoundsConfiguration = {
    sounds: {}
};
